import React, { Fragment, useContext, useState } from "react";
import { FaCaretDown, FaSignOutAlt } from "react-icons/fa";
import { Link, useNavigate } from "react-router-dom";
import { AuthContext } from "../../context";
import { adminLinks } from "./link";
import styles from "./styles.module.css";

const HRLinks = ({ name, roles }) => {
  const [expandedItems, setExpandedItems] = useState({});
  const navigate = useNavigate();
  const authCtx = useContext(AuthContext);

  const toggleHandler = (id) => {
    setExpandedItems((prevExpandedItems) => ({
      ...prevExpandedItems,
      [id]: !prevExpandedItems[id],
    }));
  };
  const hasPermission = (allowed) => allowed.includes(roles);
  console.log(roles);
  const logout = () => {
    authCtx.logout();
    navigate("/");
  };

  return (
    <div className={styles.links}>
      <ul>
        {adminLinks.map((item, index) => (
          <Fragment key={index}>
            {hasPermission(item.allowed) && (
              <Fragment key={index}>
                {item.children ? (
                  <div className={styles.childContainer}>
                    <li
                      className={name === item.name ? styles.active : undefined}
                      onClick={() => toggleHandler(index)}
                    >
                      <span>
                        <item.Icon />
                        {item.name}
                        &nbsp;&nbsp;
                        <FaCaretDown />
                      </span>
                    </li>
                    {expandedItems[index] && (
                      <div className={styles.child}>
                        <ul>
                          {item.children.map((child, childIndex) => (
                            <li key={childIndex}>
                              <Link to={child.route}>
                                <child.Icon />
                                {child.name}
                              </Link>
                            </li>
                          ))}
                        </ul>
                      </div>
                    )}
                  </div>
                ) : (
                  <li
                    key={index}
                    className={name === item.name ? styles.active : undefined}
                  >
                    <Link to={item.route}>
                      <item.Icon />
                      {item.name}
                    </Link>
                  </li>
                )}
              </Fragment>
            )}
          </Fragment>
        ))}
        <li>
          <span onClick={logout}>
            <FaSignOutAlt />
            Logout
          </span>
        </li>
      </ul>
    </div>
  );
};

export default HRLinks;
